function initialState () {
	return {
		myExperiences: [
			{
				id: 0,
				title: 'My Experience',
				chosenSpace: {
					id: 0,
					title: 'My Space',
					nodes: [
						{
							id:1,
							name: "CONTROLLER",
							iconComponent:"controller-icon",
							x:-384,
							y:50,
							dropzone: true,
							input: false,
							display: false,
							video: false,
							audio: false,
							light: false,
							control: true,
							effect: false
						}
					],
					links: []
				},
				nodes: [],
				links: []
			}
		]
	};
}

export default {
	state: initialState,
	getters: {
		myExperiences: state => state.myExperiences
	},

	mutations: {
		saveScene(state, sceneObj) {
			let sceneIndex = null;
			let objectExists = state.myExperiences.filter(function(el, index){
				if (el.id == sceneObj.id) {sceneIndex = index;}
				return el.id == sceneObj.id;
			})[0];
			if (objectExists) {
				state.myExperiences.splice(sceneIndex, 1, sceneObj);
			} else {
				state.myExperiences.push(sceneObj);
			}
		},

		deleteScene(state, sceneObj) {
			let sceneIndex = null;
			let objectExists = state.myExperiences.filter(function(el, index){
				if (el.id == sceneObj.id) {sceneIndex = index;}
				return el.id == sceneObj.id;
			})[0];
			if (objectExists) {
				state.myExperiences.splice(sceneIndex, 1);
			}
		},

		setSceneChosenSpace(state, payload) {
			let epxId = payload.experienceId;
			state.myExperiences[epxId].chosenSpace = payload.spaceObj;
		},

		resetMyExperiences (state) {
			Object.assign(state, initialState());
		}
	},

	actions: {
		saveScene({commit}, payload) {
			return new Promise((resolve, reject) => {
				commit('saveScene', payload.sceneObj);
				resolve();
			});
		},

		deleteScene({commit}, payload) {
			return new Promise((resolve, reject) => {
				commit('deleteScene', payload.sceneObj);
				resolve();
			});
		},

		setSceneChosenSpace({commit}, payload) {
			return new Promise((resolve, reject) => {
				commit('setSceneChosenSpace', payload);
				resolve();
			});
		},

		resetMyExperiences ({commit}) {
			return new Promise((resolve, reject) => {
				commit('resetMyExperiences');
				resolve();
			});
		}
	}
}